export default __webpack_public_path__ + "static/media/cutter.07033099.png";